import { RequestCommissionChangeCTA } from "@faire/help-center-self-serve/brand/instantAnswers/ctas";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var requestCommissionUpdate = function requestCommissionUpdate(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getRequestCommission;
        return (_getRequestCommission = getRequestCommissionChangeCTA(context, strictLocalize)) === null || _getRequestCommission === void 0 ? void 0 : _getRequestCommission.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getRequestCommission2, _getRequestCommission3;
        return (_getRequestCommission2 = getRequestCommissionChangeCTA(context, strictLocalize)) === null || _getRequestCommission2 === void 0 ? void 0 : (_getRequestCommission3 = _getRequestCommission2.getLink) === null || _getRequestCommission3 === void 0 ? void 0 : _getRequestCommission3.call(_getRequestCommission2);
      }
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.FaireDirect.ORDER_COMMISSION ? articlePage(articles.FaireDirect.ORDER_COMMISSION.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = _context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (!brandOrderToken) {
    return {
      getTitle: function getTitle() {
        return strictLocalize({
          id: "LNjxMH",
          defaultMessage: [{
            "type": 0,
            "value": "Zo werk je de commissie bij naar 0%"
          }]
        });
      },
      getDescription: function getDescription() {
        return [strictLocalize({
          id: "6NulTy",
          defaultMessage: [{
            "type": 0,
            "value": "We werken een bestelling graag bij naar 0% commissie als je documentatie levert over je relatie met een retailer die hiervoor in aanmerking komt. Deze documentatie kan worden ingediend door te klikken op ‘Commissiewijziging aanvragen’ op de specifieke bestelpagina in je merkportaal of hieronder. Na het indienen zal ons team je verzoek bekijken en je binnen 2 werkdagen per e-mail een update sturen."
          }]
        })];
      }
    };
  }
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "fYRs9C",
        defaultMessage: [{
          "type": 0,
          "value": "Zo werk je de commissie voor deze bestelling bij naar 0%"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "DNYfPe",
        defaultMessage: [{
          "type": 0,
          "value": "We werken een bestelling graag bij naar 0% commissie als je documentatie levert over je relatie met een retailer die hiervoor in aanmerking komt. Deze documentatie kan worden ingediend door te klikken op ‘Commissiewijziging aanvragen’ op de specifieke bestelpagina in je merkportaal of hieronder. Na het indienen zal ons team je verzoek bekijken en je binnen 2 werkdagen per e-mail een update sturen."
        }]
      })];
    }
  };
};
var getRequestCommissionChangeCTA = function getRequestCommissionChangeCTA(context, strictLocalize) {
  var _context$brandOrder2, _context$brandOrder2$;
  var brandOrderToken = (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token;
  if (!brandOrderToken) {
    return undefined;
  }
  return RequestCommissionChangeCTA(brandOrderToken, strictLocalize);
};